import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import useMatchMediaQuery from 'Shared/Hooks/useMediaQuery';

import Loadable from 'Shared/Loadable';

import useMe from 'Shared/Hooks/useMe';

import { DATABR, DATA } from './i18nDataItems';

import { LeftProps } from '../../types';

const Left: FC<Omit<LeftProps, 'data' | 'comunityI18NItems'>> = props => {
  const { t } = useTranslation();
  const { me: user } = useMe();

  const { matches: isDesktop } = useMatchMediaQuery('md');
  const { countryPrefix, crehanaBaseUrl } = props;

  const isOrganization = user && user.hasOrganization;
  const slugOrg = user && user.organization ? user.organization.slug : '';
  const isAffiliate =
    user && user.originalId && user.isAffiliate && !isOrganization;

  const countryPrefixUrl = countryPrefix
    ? `/${countryPrefix.toLowerCase()}`
    : '';
  const DATA_AVAILABLE_REGION = countryPrefix === 'br' ? DATABR : DATA;
  const DATA_FORMATED = {
    ...DATA_AVAILABLE_REGION(t, crehanaBaseUrl || '', {
      countryPrefix: countryPrefixUrl,

      slugOrg,

      isAffiliate,
    }),
  };

  return isDesktop ? (
    <Loadable
      module={() =>
        import(/* webpackChunkName: "mainmenu-left-desktop" */ './Desktop')
      }
      {...props}
      data={DATA_FORMATED}
      comunityI18NItems={
        !isOrganization
          ? DATA_FORMATED.comunityMobile
          : DATA_FORMATED.premiumCommunity
      }
    />
  ) : (
    <Loadable
      module={() =>
        import(/* webpackChunkName: "mainmenu-left-mobile" */ './Mobile')
      }
      {...props}
      data={DATA_FORMATED}
      comunityI18NItems={
        !isOrganization
          ? DATA_FORMATED.comunityMobile
          : DATA_FORMATED.premiumCommunity
      }
    />
  );
};

export default Left;
